export interface AiErrorResponse {
  error: string;
  code?: string;
  details?: Record<string, unknown>;
}

export const AI_ERROR_CODES = {
  CREDITS_LIMIT_REACHED:    'ai.credits.limit_reached',
  /** Reserva gratuita zerada com a janela ainda aberta. `details.refill_at` sempre preenchido. */
  TANK_EMPTY:               'ai.credits.tank_empty',
  SUBSCRIPTION_NOT_FOUND:   'ai.subscription.not_found',
  RATE_LIMIT_USER:          'ai.rate_limit.user',
  RATE_LIMIT_CONCURRENT:    'ai.rate_limit.concurrent',
  RATE_LIMIT_IP:            'ai.rate_limit.ip',
  SERVICE_AT_CAPACITY:      'ai.service.at_capacity',
  SERVICE_INTERNAL_ERROR:   'ai.service.internal_error',
  TIMEOUT:                  'ai.timeout',
  GUARDRAIL_INPUT_BLOCKED:  'ai.guardrail.input_blocked',
  GUARDRAIL_OUTPUT_BLOCKED: 'ai.guardrail.output_blocked',
  PROFILES_UNAVAILABLE:     'ai.service.profiles_unavailable',
  ACCESS_NONE:              'ai.access.none',
  PROFILE_TOO_LONG:         'ai.validation.profile_too_long',
} as const;
